import { render, staticRenderFns } from "./addBrandAndType.vue?vue&type=template&id=5f96622e&scoped=true"
import script from "./addBrandAndType.vue?vue&type=script&lang=js"
export * from "./addBrandAndType.vue?vue&type=script&lang=js"
import style0 from "./addBrandAndType.vue?vue&type=style&index=0&id=5f96622e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f96622e",
  null
  
)

export default component.exports